import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { BadgeComponent, BadgeStatus } from 'vcp-common-ui-lib';
import { AssessmentStatus } from '../../model/assessment-status.enum';

@Component({
    selector: 'vc-assessment-status-chip',
    templateUrl: './assessment-status-chip.component.html',
    styleUrls: ['./assessment-status-chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BadgeComponent, TranslocoPipe],
})
export class AssessmentStatusChipComponent {
    statusClrMap: Map<AssessmentStatus, BadgeStatus> = new Map<AssessmentStatus, BadgeStatus>()
        .set(AssessmentStatus.NOT_STARTED, 'info')
        .set(AssessmentStatus.PRE_ASSESSMENT, 'info')
        .set(AssessmentStatus.IN_PROGRESS, 'info')
        .set(AssessmentStatus.PAUSED, 'warning')
        .set(AssessmentStatus.DELAYED, 'error')
        .set(AssessmentStatus.SUBMITTED_TO_QA, 'warning')
        .set(AssessmentStatus.IN_QA, 'info')
        .set(AssessmentStatus.RETURN_TO_ASSESSOR, 'warning')
        .set(AssessmentStatus.READY_FOR_DELIVERY, 'warning')
        .set(AssessmentStatus.CANCELED, 'info')
        .set(AssessmentStatus.COMPLETED, 'success');

    statusIconMap: Map<AssessmentStatus, string> = new Map<AssessmentStatus, string>()
        .set(AssessmentStatus.NOT_STARTED, 'remove_circle_outline')
        .set(AssessmentStatus.PRE_ASSESSMENT, 'access_time')
        .set(AssessmentStatus.IN_PROGRESS, 'play_circle_outline')
        .set(AssessmentStatus.PAUSED, 'pause_circle_outline')
        .set(AssessmentStatus.DELAYED, 'assignment_late')
        .set(AssessmentStatus.SUBMITTED_TO_QA, 'assignment_returned')
        .set(AssessmentStatus.IN_QA, 'assignment_returned')
        .set(AssessmentStatus.RETURN_TO_ASSESSOR, 'assignment_return')
        .set(AssessmentStatus.READY_FOR_DELIVERY, 'assignment_turned_in')
        .set(AssessmentStatus.CANCELED, 'cancel')
        .set(AssessmentStatus.COMPLETED, 'check_circle');

    @Input()
    status!: AssessmentStatus;
}
